export default __webpack_public_path__ + "static/media/diamond.c00485d8.svg";